import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth/auth.guard';
import { NotLoggedinGuard } from './guards/auth/notloggedin.guard';
import { NotFoundComponent } from './new-pages/others/not-found/not-found.component';
import { ForbiddenComponent } from './new-pages/others/forbidden/forbidden.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./new-pages/auth/login/login.module').then(
        (m) => m.LoginPageModule
      ),
    canActivate: [NotLoggedinGuard],
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./new-pages/auth/register/register.module').then(
        (m) => m.RegisterPageModule
      ),
    canActivate: [NotLoggedinGuard],
  },
  {
    path: 'show-map',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/show-map/show-map.module').then(
        (m) => m.ShowMapPageModule
      ),
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./new-pages/landing/landing.module').then(
        (m) => m.LandingPageModule
      ),
  },
  {
    path: 'registration-checking',
    loadChildren: () =>
      import(
        './new-pages/auth/registration-checking/registration-checking.module'
      ).then((m) => m.RegistrationCheckingPageModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./new-pages/admin/admin.module').then((m) => m.AdminPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'not-found-404',
    component: NotFoundComponent,
  },
  {
    path: 'forbidden-403',
    component: ForbiddenComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found-404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
